import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  categoryId: string;
};

export const getReportCategoryUsers = createQueryFn(
  QueryNameSpace.getReportCategoryUsers,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const res = await DigiobcanApi.getReportCategoryUsers(params.categoryId);

    return res.users || [];
  },
);
